import {EventDateType, EventType} from "globals/types/models.ts";
import {LANGS} from "globals/constants.ts";
import {getClosestNextDate} from "utils/data/event.ts";
import {EnumLangType} from "globals/types/globals.ts";
import dayjs from 'dayjs'

export const getEventSchema = (event: EventType, currentLang: EnumLangType) => {
    const eventTitle = currentLang === LANGS.FR ? event.titleFr : event.titleEn ? event.titleEn : event.titleFr
    const eventDescription = currentLang === LANGS.FR ? event.descriptionFr : event.descriptionEn ? event.descriptionEn : event.descriptionFr
    const closestDate = getClosestNextDate<EventDateType>(event.dates)

    //just use the first one, if the event is finish for example
    const date = closestDate ? closestDate : event.dates.length > 0 ? event.dates[0] : null

    return {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": eventTitle,
        "description": eventDescription,
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
            "@type": "Place",
            "name": event.address,
            "address": {
                "@type": "PostalAddress",
                "streetAddress": event.address,
                "addressLocality": event.city,
                "postalCode": event.zipcode,
                "addressRegion": event.state,
                "addressCountry": event.country
            }
        },
        'offers': {},
        'performer': {},
        'organizer': {},
        "image": event.images.map(i => i.imageUrl),
        ...(date ? {
            "startDate": dayjs(date.startDate).format(),
            "endDate": dayjs(date.endDate).format(),
        } : {})
    }


}
